import { Component } from '@angular/core'

import {
    AngularMenuItem,
    BaseWebApiService,
    DialogsService,
    NavigationService
} from 'angular-library';
import { UserService } from '../services/user.service';

@Component({
    moduleId: module.id,
    selector: 'pagemaster',
    templateUrl: 'pagemaster.html'
})
export class PageMasterComponent {
    menuCollapsed: boolean = true;
    homePageAction: string = 'index';
    asyncWaiting: boolean = false;
    longAsyncWaiting: boolean = false;
    basServiceSubscription: any;
    basServiceSubscriptionError: any;
    myUserService: UserService;
    myNavigationService: NavigationService;

    constructor(private baseService: BaseWebApiService,
        private userService: UserService,
        private navigationService: NavigationService,
        private dialogsService: DialogsService) {
        this.basServiceSubscription = this.baseService.isAsyncWaiting.subscribe(value => this.asyncWaiting = value);
        this.basServiceSubscription = this.baseService.isLongAsyncWaiting.subscribe(value => this.longAsyncWaiting = value);
        this.basServiceSubscriptionError = this.baseService.isAsyncError.subscribe(value => {
            if (value.isError) this.dialogsService.alert("Errore", value.message);
        });
        this.menuCollapsed = true;
        this.myUserService = this.userService;
        this.myNavigationService = this.navigationService;
    }

    ngOnDestroy() {
        this.basServiceSubscription.unsubscribe();
        this.basServiceSubscriptionError.unsubscribe();
    }

    toggleMenu(type: number): void {
        this.menuCollapsed = !this.menuCollapsed;
    }

    doLogout() {
        this.userService
            .logout()
            .then(logoutResponse => {
            });
        return false;
    }

    menuClick(item: AngularMenuItem) {
        this.menuCollapsed = true;
        this.navigationService.menuNavigate(item)
    }
}


// WEBPACK FOOTER //
// ./src/app/core/masterComponent/pagemaster.component.ts